package io.github.kingsword09.symbolcraft.symbols.icons.`simple-icons`.icons

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import io.github.kingsword09.symbolcraft.symbols.icons.`simple-icons`.Icons

public val Icons.Playstation4SimpleIcons: ImageVector
    get() {
        if (_playstation4SimpleIcons != null) {
            return _playstation4SimpleIcons!!
        }
        _playstation4SimpleIcons = Builder(name = "Playstation4SimpleIcons", defaultWidth = 24.0.dp, defaultHeight = 24.0.dp, viewportWidth = 24.0f, viewportHeight = 24.0f).apply {
            path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f, pathFillType = NonZero) {
                moveTo(12.30f, 13.18f)
                verticalLineToRelative(-2.39f)
                curveToRelative(0.0f, -0.49f, 0.23f, -0.83f, 0.71f, -0.83f)
                horizontalLineToRelative(2.99f)
                curveToRelative(0.02f, 0.0f, 0.04f, -0.02f, 0.04f, -0.04f)
                verticalLineToRelative(-0.48f)
                curveToRelative(0.0f, -0.00f, 0.0f, -0.01f, -0.00f, -0.01f)
                horizontalLineToRelative(-3.66f)
                curveToRelative(-0.79f, 0.1f, -1.18f, 0.65f, -1.18f, 1.36f)
                verticalLineToRelative(2.39f)
                curveToRelative(0.0f, 0.48f, -0.23f, 0.83f, -0.71f, 0.83f)
                lineTo(7.33f, 14.01f)
                curveToRelative(-0.02f, 0.0f, -0.04f, 0.01f, -0.04f, 0.04f)
                verticalLineToRelative(0.48f)
                curveToRelative(0.0f, 0.02f, 0.01f, 0.04f, 0.02f, 0.04f)
                horizontalLineToRelative(3.58f)
                curveToRelative(0.93f, -0.03f, 1.39f, -0.62f, 1.39f, -1.39f)
                close()
                moveTo(0.02f, 14.56f)
                horizontalLineToRelative(1.05f)
                arcToRelative(0.04f, 0.04f, 0.0f, false, false, 0.03f, -0.04f)
                verticalLineToRelative(-1.52f)
                curveToRelative(0.0f, -0.49f, 0.28f, -0.82f, 0.68f, -0.82f)
                horizontalLineToRelative(4.32f)
                curveToRelative(0.97f, 0.0f, 1.45f, -0.6f, 1.45f, -1.38f)
                curveToRelative(0.0f, -0.71f, -0.39f, -1.26f, -1.18f, -1.36f)
                lineTo(0.01f, 9.44f)
                curveToRelative(0.0f, 0.00f, -0.01f, 0.01f, -0.01f, 0.01f)
                verticalLineToRelative(0.48f)
                curveToRelative(0.0f, 0.02f, 0.01f, 0.04f, 0.04f, 0.04f)
                horizontalLineToRelative(5.70f)
                curveToRelative(0.48f, 0.0f, 0.71f, 0.35f, 0.71f, 0.83f)
                curveToRelative(0.0f, 0.48f, -0.23f, 0.84f, -0.71f, 0.84f)
                lineTo(1.23f, 11.63f)
                curveToRelative(-0.7f, 0.0f, -1.23f, 0.59f, -1.23f, 1.37f)
                verticalLineToRelative(1.52f)
                curveToRelative(0.0f, 0.02f, 0.01f, 0.04f, 0.03f, 0.04f)
                close()
                moveTo(16.02f, 14.01f)
                horizontalLineToRelative(5.74f)
                curveToRelative(0.02f, 0.0f, 0.03f, 0.01f, 0.03f, 0.02f)
                verticalLineToRelative(0.48f)
                curveToRelative(0.0f, 0.02f, 0.02f, 0.04f, 0.04f, 0.04f)
                horizontalLineToRelative(1.04f)
                curveToRelative(0.02f, 0.0f, 0.04f, -0.01f, 0.04f, -0.04f)
                verticalLineToRelative(-0.48f)
                curveToRelative(0.0f, -0.02f, 0.02f, -0.04f, 0.04f, -0.04f)
                horizontalLineToRelative(1.03f)
                curveToRelative(0.02f, 0.0f, 0.04f, -0.02f, 0.04f, -0.04f)
                verticalLineToRelative(-0.48f)
                curveToRelative(0.0f, -0.02f, -0.01f, -0.04f, -0.04f, -0.04f)
                horizontalLineToRelative(-1.03f)
                curveToRelative(-0.02f, 0.0f, -0.04f, -0.02f, -0.04f, -0.04f)
                lineTo(22.90f, 9.96f)
                curveToRelative(0.0f, -0.28f, -0.10f, -0.46f, -0.28f, -0.52f)
                horizontalLineToRelative(-0.3f)
                arcToRelative(1.15f, 1.15f, 0.0f, false, false, -0.30f, 0.13f)
                lineToRelative(-6.18f, 3.82f)
                curveToRelative(-0.24f, 0.15f, -0.32f, 0.32f, -0.26f, 0.45f)
                curveToRelative(0.05f, 0.10f, 0.19f, 0.18f, 0.45f, 0.18f)
                close()
                moveTo(16.92f, 13.38f)
                lineToRelative(4.79f, -2.96f)
                curveToRelative(0.03f, -0.02f, 0.09f, -0.02f, 0.09f, 0.05f)
                verticalLineToRelative(2.96f)
                curveToRelative(0.0f, 0.02f, -0.02f, 0.04f, -0.03f, 0.04f)
                horizontalLineToRelative(-4.82f)
                curveToRelative(-0.04f, 0.0f, -0.06f, -0.01f, -0.07f, -0.02f)
                curveToRelative(-0.01f, -0.02f, 0.01f, -0.04f, 0.04f, -0.06f)
                close()
            }
        }
        .build()
        return _playstation4SimpleIcons!!
    }

private var _playstation4SimpleIcons: ImageVector? = null
